import { getTaskRewardDetail } from '../../../api/taskRewardsApi'
import TaskRewardDescriptions from '../../../components/task-rewards/task-reward-descroptions/task-reward-descroptions'
import { ITaskReward } from '../share-type'
import styles from './task-reward.module.less'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const TaskReward = () => {
  const params = useParams()
  const [taskRewardId] = useState<string | undefined>(params?.id)
  const [taskReward, setTaskReward] = useState<ITaskReward>()
  useEffect(() => {
    if (taskRewardId) {
      getTaskReward(Number(taskRewardId))
    }
  }, [taskRewardId])

  const getTaskReward = (id: number) => {
    getTaskRewardDetail(id).then(res => {
      setTaskReward(res)
    })
  }

  return (
    <Space className={styles['task-reward-desc-wrapper']} orientation="vertical" size={16}>
      {taskReward && <TaskRewardDescriptions taskReward={taskReward} />}
    </Space>
  )
}

export default TaskReward
